import { Fragment } from 'react'

const PHONE_PATTERN = /(1300\s?296\s?296)/g

function renderWithBoldPhone(text: string, keyPrefix: string) {
  const segments = text.split(PHONE_PATTERN)
  return segments.map((seg, i) => {
    const isPhone = /^1300\s?296\s?296$/.test(seg)
    return isPhone ? (
      <span key={`${keyPrefix}-${i}`} className="font-semibold">{seg}</span>
    ) : (
      <Fragment key={`${keyPrefix}-${i}`}>{seg}</Fragment>
    )
  })
}

type Props = {
  message: string
  className?: string
}

/** Renders a portal-block message with the first line bold and any Club 4X4 phone numbers bolded. */
export default function PolicyBlockedMessageBody({ message, className }: Props) {
  const trimmed = message.trim()
  const splitAt = trimmed.indexOf('\n\n')
  const firstLine = splitAt === -1 ? trimmed : trimmed.slice(0, splitAt)
  const rest = splitAt === -1 ? '' : trimmed.slice(splitAt)
  return (
    <p className={`whitespace-pre-wrap ${className ?? ''}`.trim()}>
      <span className="font-semibold">{firstLine}</span>
      {rest && renderWithBoldPhone(rest, 'phone')}
    </p>
  )
}
